import React, { useMemo } from "react";
import styled from "styled-components";
import { splitLinkLabel } from "../utils/stringUtils";

interface Props {
  label: string;
  onClick: () => void;
}

const ButtonLabel = ({ label, onClick }: Props) => {
  const labelObject = useMemo(() => {
    try {
      return splitLinkLabel(label);
    } catch (error) {}
  }, [label]);

  return labelObject ? (
    <>
      {`${labelObject.prefix} `}
      <Button onClick={onClick} type="button">
        {labelObject.content}
      </Button>
      {` ${labelObject.suffix}`}
    </>
  ) : (
    <>{label}</>
  );
};

const Button = styled.button`
  appearance: none;
  background: transparent;
  border: none;
  color: #409ef5;
  cursor: pointer;
  font-size: inherit;
  font-weight: 600;
  margin: 0;
  padding: 0;
  text-decoration: underline;
`;

export default ButtonLabel;
